export function getDocumentationInfo(data) {
  if (data.DocumentalCategories.length > 0) {
    const listOfDocGroups = data.DocumentalCategories[0].DocumentalGroups
      .map((group) => {
        return group.Documents.map((document) => {
          return {
            grupo: group.Name,
            nombre: document.Name,
            id: document.Id,
            validacion: document.Validation.Approved,
            fechaDeVal: document.Validation.ValidationDate
          }
        })
      })

    const documentation = listOfDocGroups.reduce((a, b) => [...a, ...b], []);
    return documentation
  } else {
    return []
  }
}

export function getOptions(data) {
  if (data.DocumentalCategories.length > 0) {
    const grupos = data.DocumentalCategories[0].DocumentalGroups
      .map((group) => {
        return group.Name
      })
    return grupos
  } else {
    return []
  }
}

export function getDocsForApproval(data) {
  if (data.Stage.DocumentalCategory != null || undefined) {
    let docstoApproved = data.Stage.DocumentalCategory?.DocumentalGroups?.map((docGroup) => {
      return docGroup.DocumentTypes
        .filter(docType => docType.Document != null)
    }).filter(doc => doc.length > 0).map((document) => {
      return document.map((validDoc) => {
        return validDoc
      })
    }).reduce((a, b) => [...a, ...b], []);

    return docstoApproved

  } else {
    return []
  }
}

export function getChecksStage(data) {
  if (data.Properties?.length > 0) {
    let listCheksDefinicion = data.Properties.find(item => item.Name == "ChecksDefinition")?.Value
    let activeGeolocationRaw = data.Properties.find(item => item.Name == "ActiveGeolocation")?.Value
    let geolocationTextRaw = data.Properties.find(item => item.Name == "GeolocationTextCheck")?.Value

    if (listCheksDefinicion != undefined && listCheksDefinicion != null && listCheksDefinicion?.trim() != "") {
      let modelCheckDeninicion = JSON.parse(listCheksDefinicion);
      if (activeGeolocationRaw) {
        modelCheckDeninicion[modelCheckDeninicion.length] = {
          Required: true,
          TextCheck: geolocationTextRaw?.trim(),
          Send: false
        }
      }

      return modelCheckDeninicion.map((item, index) => {
        console.log("---------------------.......item...........-----------: ", item)
        return {
          ...item,
          Name: item.TextCheck?.replace(/[ .]/g, "_")?.replace("<b>", "")?.slice(0, item.TextCheck.length > 48 ? 48 : item.TextCheck.length),
          Label: item.TextCheck,
          Required: item.Required,
          Value: null
        }
      });
    } else {
      return []
    }
  } else {
    return []
  }
}

export function getValidations(data) {
  // console.log(".....data.Stage.DocumentalCategory?.DocumentalGroups......: ", data.Stage.DocumentalCategory?.DocumentalGroups)  
  // console.log(".????????????..........getSections--111--??????: ", data)
  let listDocumentFilter = data.Stage?.DocumentalCategory?.DocumentalGroups.filter(item => item.DocumentTypes.some(itemDoc => itemDoc.Document != undefined))
  //  console.log(".????????????..........listDocumentFilter15--some--??????: ", listDocumentFilter)
  let objectDocument = listDocumentFilter?.map(item => item.DocumentTypes?.filter(itemDoc => itemDoc.Document != undefined)[0])[0]
  //  console.log(".????????????..........objectDocument101----??????: ", objectDocument)

  let ActiveFVerification = objectDocument?.Properties?.find(item => item.Name == "ActiveFacialVerification")

  // console.log("------- Validations File Info:-------- ", ActiveFVerification)
  // console.log("------- Validations File Info:-------- ", data.Validation)

  let validationFile = (data.Validation?.Results === undefined || data.Validation?.Results === null ? false :
    (data.Validation?.Results[0]?.Approved === true &&
      data.Validation?.Results[0]?.Value == "True" && data.Validation?.Approved === true ? true : false))

  return {
    ActiveFacialVerification: ActiveFVerification?.Value,
    ValidationFile: validationFile
  }
}

export function getSections(data, dataStage) {
  // console.log(".????????????..........getSections----??????: ", data, " --dataStage- ", dataStage)
  let listDocumentFilter = dataStage?.DocumentalCategory?.DocumentalGroups.filter(item => item.DocumentTypes.some(itemDoc => itemDoc.Document != undefined))
  //  console.log(".????????????..........listDocumentFilter5--some--??????: ", listDocumentFilter)
  let objectDocument = listDocumentFilter?.map(item => item.DocumentTypes?.filter(itemDoc => itemDoc.Document != undefined)[0])[0]
  //  console.log(".????????????..........objectDocument10----??????: ", objectDocument)

  // let listDocument = dataStage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes?.filter(item => item.Document != null)
  // let nameFInd = listDocument != undefined && listDocument != null ? listDocument[listDocument.length - 1]?.Document?.Name : "DNI"
  let nameFInd = objectDocument?.Document?.Name
  // console.log("listDocument----: ", nameFInd, " --- ", listDocument)
  let lisSections = data?.find(item => (item.Name != "Formato autogenerado"))?.
    Documents?.find(item => item.Name === (nameFInd != null && nameFInd != undefined && nameFInd != "" ? nameFInd : "INE / IFE"))?.Sections?.
    filter(sec => !sec.Name.includes('Minucia'))?.map((secc) => {
      return secc.Id
    })
  console.log("List Sections personalize: ", lisSections)
  return {
    Sections: lisSections
  }
}


export function getNameDocINE(data, dataStage) {
  // console.log(".????????????..........listDocument----??????: ", data, " --dataStage- ", dataStage)
  let listDocumentFilter = dataStage?.DocumentalCategory?.DocumentalGroups.filter(item => item.DocumentTypes.some(itemDoc => itemDoc.Document != undefined))
  // console.log(".????????????..........listDocumentFilter--some--??????: ", listDocumentFilter)
  let objectDocument = listDocumentFilter?.map(item => item.DocumentTypes?.filter(itemDoc => itemDoc.Document != undefined)[0])[0]
  console.log(".????????????..........objectDocument111114----??????: ", objectDocument)

  let nameFInd = objectDocument?.Document?.Name
  // console.log("listDocument----: ", nameFInd, " --- ")
  let docNameVale = data?.find(item => (item.Name != "Formato autogenerado"))?.
    Documents?.find(item => item.Name === (nameFInd != null && nameFInd != undefined && nameFInd != "" ? nameFInd : "INE / IFE"))?.Name
  console.log("getNameDocs: ", docNameVale)
  return {
    Name: docNameVale === undefined || docNameVale === null ? nameFInd : docNameVale,
    DocumentId: objectDocument?.Document?.Id,
    Properties: objectDocument?.Properties,
    Sections: objectDocument?.Sections
  }
}


export function getNameDocEvidence(data) {
  let listDocument = data?.find(item => (item.Code == "Identificación oficial" || item.Name == "Cédula de Identidad"))?.Documents

  // console.log("listDocument----: ", listDocument)
  // console.log("getNameDocs: ", docNameVale)
  if (listDocument === undefined || listDocument === null || listDocument?.length == 0) {
    return {
      Id: null,
      Name: null,
    }
  } else {
    return {
      Id: listDocument[0]?.Id,
      Name: listDocument[0]?.Name
    }
  }
}


///Metodos nuevos de authenticacion, extraer nuevas variables.
export function getDataModules(data) {
  let IsDashboard = data.UserLoginData.SecurityLoginData.Applications
    ?.find(item => item.Name == "OnBoarding")
    ?.Modules.find(item => item.Name == "Home")
    ?.Functions.find(item => item.Name == "Dashboard")

  let IsGenerarSolicitudes = data.UserLoginData.SecurityLoginData.Applications
    ?.find(item => item.Name == "OnBoarding")
    ?.Modules.find(item => item.Name == "Home")
    ?.Functions.find(item => item.Name == "Generar Solicitudes")

  let IsBusqueda = data.UserLoginData.SecurityLoginData.Applications
    ?.find(item => item.Name == "OnBoarding")
    ?.Modules.find(item => item.Name == "Home")
    ?.Functions.find(item => item.Name == "Busqueda")

  console.log("IsDashboard: ", IsDashboard)
  console.log("IsGenerarSolicitudes: ", IsGenerarSolicitudes)
  console.log("IsBusqueda: ", IsBusqueda)
  return {
    dashboardData: IsDashboard,
    generarSolicitudesData: IsGenerarSolicitudes,
    busquedaData: IsBusqueda,
  }
}